import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { academylist, listevent } from "../../../services/admin";
import moment from "moment";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function CertificateList() {

    const [events, setEvents] = useState([]);
    const [aclist, setACList] = useState([]);
    const [acaid, setAcaID] = useState("");

    useEffect(() => {

        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setACList(arr);
                }
            }
        });
        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                                listall(arr[0]);
                            }
                        }

                    }
                }
            });
        } else {
            listall("");
        }
    }, []);
    const navigate = useNavigate();
    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 100,
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a title="Merit List" onClick={() => navigate("/certificate/uploadcertificate/" + params.value)}
                            className="btn-sm btn-info me-2"
                        >
                            <i className="fas fa-trophy"></i>
                        </a>
                        <a title="Participant List"  onClick={() => navigate("/certificate/uploadcertificate/" + params.value)}
                            className="btn-sm btn-warning me-2"
                        >
                            <i className="fas fa-users"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Event",
            field: "event_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Start Date",
            field: "event_start",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },

        },
        {
            headerName: "End Date",
            field: "event_end",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },

        },
        {
            headerName: "Location",
            field: "location",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Certificate",
            field: "issue_certificate",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academy",
            field: "academy_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);

        } else {
            setAcaID("");
        }
    }

    function listall(lid) {
        setEvents([]);
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && lid !== "") {
            temp.append("academy_id", lid.value);
        }
        listevent(temp).then((res) => {
            if (res.status === true) {
                // setEvents(res.data.details);
                if (res.data.details.length > 0) {
                    const ddata = res.data.details
                        .filter((item) => item.issue_certificate == "Yes")
                        .map((item) => {
                            return {
                                ...item,
                                event_start: moment(item.event_start).format("DD-MM-YYYY"),
                                event_end: moment(item.event_end).format("DD-MM-YYYY"),
                            };
                        })
                    setEvents(ddata);
                }
            }
        })
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Events List</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Calendar</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Events List
                    </li>
                </ol>
            </div>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">

                            {localStorage.getItem("Role") === "1" && (
                                <div className="row">
                                    <div className="col-xl-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Select Academy{" "}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Academy"
                                                value={acaid}
                                                options={aclist}
                                                onChange={handleAcademy}
                                                isSearchable={true}
                                                isClearable
                                                hidden
                                            />
                                        </div>
                                    </div>

                                </div>
                            )}


                            <div className="ag-theme-alpine ag-style">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={events}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={["asc", "desc"]}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>
                            {/* <Modal show={show} size="lg" onHide={() => setShow(false)}>
                                <Modal.Header>
                                    <Modal.Title>Certificate</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="row">
                                        <div className="col-xl-12">

                                            <img src={require("../../../assets/images/certificate.jpeg")} />
                                        </div>

                                    </div>
                                </Modal.Body>
                                <Modal.Footer>

                                    <a className="btn btn-danger" onClick={() => setShow(false)}>
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal> */}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

   
}
